module.exports = __webpack_public_path__ + "static/media/f4d-black-transparent-p-500.1a283e35.png";